import ATBNew from './views/atb-new.c.js';
export default ATBNew;
